/* eslint-disable react/prop-types */
// Eslint está acusando alguns falsos-positivos nessa regra nesse arquivo (no blockToHTML do convertToHTML)

import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/server";
import { CompositeDecorator, EditorBlock, genKey, ContentState } from "draft-js";
import { createPortal } from "react-dom";
import MultiDecorator from "draft-js-plugins-editor/lib/Editor/MultiDecorator";
import { convertFromHTML as convertFromHTMLDraftJs, convertToHTML as convertToHTMLDraftJs } from "draft-convert";
import { reduce, camelCase, isEmpty } from "lodash";
import { getSelectionEntity } from "draftjs-utils";
import { get } from "dot-prop-immutable";
import { Map } from "immutable";

import { convertStyleStringToObject } from "../string/string";
import EditorTextoDecoratorDinamico from "../../components/EditorTextoDecoratorDinamico";
import EditorTextoMedia from "../../components/EditorTextoMedia";

export const defaultEditorStyles = ["BOLD", "ITALIC", "UNDERLINE", "CODE", "STRIKETHROUGH"];
const TABLE_POSITION = "tablePosition";
const TABLE_SHAPE = "tableShape";

export const blockRendererFn = block => {
  if (block.getType() === "atomic") {
    return {
      component: EditorTextoMedia,
      editable: false,
    };
  }

  return null;
};

export const Table = props => {
  const {
    block,
    blockProps: { editor },
  } = props;

  const [portalTarget, setPortalTarget] = useState(null);
  useEffect(
    () => {
      if (block.getData().get(TABLE_POSITION) && !block.getData().get(TABLE_SHAPE) && editor) {
        const position = block.getData().get(TABLE_POSITION);
        const target = editor.querySelector(`[data-position='${position}']`);

        if (target && target !== portalTarget) {
          setPortalTarget(target);
        }
      }
    },
    [editor, block, portalTarget]
  );

  if (block.getData().get(TABLE_POSITION) && !block.getData().get(TABLE_SHAPE)) {
    if (portalTarget) {
      return createPortal(<EditorBlock {...props} />, portalTarget);
    }
  }
  const data = block.getData();
  const tableKey = data.get("tableKey");
  const tableStyle = Map(data.get("tableStyle"))
    .mapKeys(k => camelCase(k))
    .toJS();
  const tableShape = data.get(TABLE_SHAPE);
  const colgroup = data.get("tableColgroup");

  if (Array.isArray(tableShape)) {
    return (
      <table key={tableKey} style={tableStyle} id={tableKey}>
        {colgroup && <colgroup dangerouslySetInnerHTML={{ __html: colgroup }} />}
        <tbody>
          {tableShape.map((row, i) => (
            <tr
              key={i}
              style={
                data.get("rowStyle")[i] &&
                Map(data.get("rowStyle")[i])
                  .mapKeys(k => camelCase(k))
                  .toJS()
              }
            >
              {row.map((cell, j) => {
                const cellStyle = Map(cell.style)
                  .mapKeys(k => camelCase(k))
                  .toJS();
                if (cell.element === "th") {
                  return (
                    <th
                      key={j}
                      style={cellStyle}
                      colSpan={cell.colspan}
                      rowSpan={cell.rowspan}
                      data-position={`${tableKey}-${i}-${j}`}
                    >
                      {Boolean(i === 0 && j === 0) && <EditorBlock {...props} />}
                    </th>
                  );
                }
                return (
                  <td
                    key={j}
                    style={cellStyle}
                    colSpan={cell.colspan}
                    rowSpan={cell.rowspan}
                    data-position={`${tableKey}-${i}-${j}`}
                  >
                    {Boolean(i === 0 && j === 0) && <EditorBlock {...props} />}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
  return <EditorBlock {...props} />;
};

let chaveTabela;
export const stateFromHtmlOptions = {
  customBlockFn: element => {
    const style = element.getAttribute("style") || "";
    const className = element.getAttribute("class") || "";
    let data = convertStyleStringToObject(style) || {};
    data = className
      .split(" ")
      .filter(c => c.length)
      .reduce((map, c) => {
        const key = c.includes("depth") ? "depth" : c;
        const val = key === "depth" ? +c.slice(5) : "class";
        map[key] = val;
        return map;
      }, data);

    const isFigure = element.tagName === "FIGURE" && element.firstChild?.tagName === "IMG";
    const isImg = element.tagName === "IMG";
    const isPWithImg = element.tagName === "P" && element.firstChild && element.firstChild.tagName === "IMG";

    if (isFigure || isImg || isPWithImg) {
      const imgEl = isImg ? element : element.firstChild;

      let height;
      if (imgEl.style.height) {
        height = removerCharsNaoNumericos(imgEl.style.height);
      } else if (imgEl.hasAttribute("height")) {
        height = imgEl.getAttribute("height");
      }

      let width;
      if (imgEl.style.width) {
        width = removerCharsNaoNumericos(imgEl.style.width);
      } else if (imgEl.hasAttribute("width")) {
        width = imgEl.getAttribute("width");
      }

      const attributes = convertAttributesToObject(imgEl.attributes);
      const imgStyle = convertStyleStringToObject(imgEl.getAttribute("style"));

      const imgData = {
        ...data,
        attributes,
        height,
        width,
        src: imgEl.getAttribute("src"),
        ...(imgStyle && { imgStyle }),
      };

      return { type: "atomic", data: imgData };
    }
    if (["TD", "TH"].includes(element.tagName)) {
      const tableEl = element.closest("table");
      const tHeadEl = element.closest("thead") ?? tableEl.querySelector("thead");
      const tBodyEl = element.closest("tbody") ?? tableEl.querySelector("tbody");
      const tableRows = tableEl.querySelectorAll("tr");
      if (tableEl.querySelector("table")) {
        return { type: "unstyled", data };
      }

      if (isEmpty(element.textContent.replace(/\s/g, ""))) {
        element.innerHTML = "&nbsp;";
      }

      const prevCell = element.previousElementSibling;
      const row = element.parentNode;
      const prevRow = row.previousElementSibling;
      if (prevCell || prevRow || (tHeadEl && [tableEl, tBodyEl].includes(row.parentNode))) {
        let found = false;
        for (let i = 0, rows = tableRows, rowCount = rows.length; i < rowCount; i++) {
          for (let j = 0, cells = rows[i].children, colCount = cells.length; j < colCount; j++) {
            if (cells[j] === element) {
              data.tableKey = chaveTabela;
              data.tablePosition = `${chaveTabela}-${i}-${j}`;
              data.colspan = cells[j].getAttribute("colspan");
              data.rowspan = cells[j].getAttribute("rowspan");
              found = true;
              break;
            }
          }
          if (found) {
            break;
          }
        }
        return { type: "table", data };
      }
      const colgroup = tableEl.querySelector("colgroup");
      const tableShape = [];
      chaveTabela = genKey();
      data.tableKey = chaveTabela;
      data.tablePosition = `${chaveTabela}-0-0`;
      data.tableStyle = convertStyleStringToObject(tableEl.getAttribute("style")) || {
        margin: "15px 0",
        width: "100%",
      };
      data.tableStyle["border-collapse"] = "collapse";
      for (let i = 0, rows = tableRows, rowCount = rows.length; i < rowCount; i++) {
        tableShape.push([]);
        const defaultStyle = {};
        if (i === 0) {
          if (element.tagName === "TH") {
            defaultStyle["background-color"] = "rgba(240, 240, 240, 0.8)";
          }
          data.rowStyle = [convertStyleStringToObject(rows[i].getAttribute("style")) || defaultStyle];
        } else {
          data.rowStyle.push(convertStyleStringToObject(rows[i].getAttribute("style")) || defaultStyle);
        }
        for (let j = 0, cells = rows[i].children, colCount = cells.length; j < colCount; j++) {
          const defaultStylee = { border: "1px solid rgba(0, 0, 0, 0.2)", padding: "6px", "text-align": "center" };
          if (cells[j].tagName === "TH") {
            defaultStylee["font-weight"] = "bold";
          }
          const cellStyle = convertStyleStringToObject(cells[j].getAttribute("style")) || defaultStylee;
          tableShape[i][j] = {
            element: cells[j].tagName === "TD" ? "td" : "th",
            style: cellStyle,
            colspan: cells[j].getAttribute("colspan"),
            rowspan: cells[j].getAttribute("rowspan"),
          };
        }
      }

      data.tableShape = tableShape;
      data.tableColgroup = colgroup?.outerHTML;
      return { type: "table", data };
    }
    return { data };
  },
  customInlineFn: (element, { Style, Entity }) => {
    if (element.tagName === "IMG") {
      return null;
    }

    if (element.tagName === "A") {
      const href = element.getAttribute("href");
      const target = element.getAttribute("target");
      const id = element.getAttribute("id");

      const attributesRaw = convertAttributesToObject(element.attributes);
      const attributes = {
        ...attributesRaw,
        href,
        target: target || attributesRaw.target,
      };

      const entityData = {
        href,
        attributes,
      };
      if (target) {
        entityData.target = target;
        entityData.rel = "noreferrer";
      }

      if (id === "linkDescadastro") {
        return Entity("LINK_DESCADASTRO_CANDENCIA", entityData, "IMMUTABLE");
      }

      return Entity("LINK", entityData, "MUTABLE");
    }
    if (element.tagName === "SPAN" && element.style.fontSize) {
      switch (element.style.fontSize) {
        case "11px":
          return Style("FONT_SIZE_11");
        case "14px":
          return Style("FONT_SIZE_14");
        case "18px":
          return Style("FONT_SIZE_18");
        case "32px":
          return Style("FONT_SIZE_32");
        default:
          break;
      }
    }
    let style = element.getAttribute("style");
    if (!style) {
      return null;
    }

    if (style.includes(";")) {
      return Style(style);
    }
    style = style.split(":");
    const key = camelCase(style.shift().trim());
    const val = style.join(":").trim();
    style = `${key}.${val}`;
    if (style === "textDecoration.underline") {
      return null;
    }
    return Style(style);
  },
};
const removerCharsNaoNumericos = str => (str ? str.replace(/[^0-9]/g, "") : undefined);
export const convertFromHTML = html =>
  convertFromHTMLDraftJs({
    htmlToStyle: (nodeName, node, currentStyle) => {
      if (nodeName === "span" && node.style.fontSize) {
        switch (node.style.fontSize) {
          case "11px":
            return currentStyle.add("FONT_SIZE_11");
          case "14px":
            return currentStyle.add("FONT_SIZE_14");
          case "18px":
            return currentStyle.add("FONT_SIZE_18");
          case "32px":
            return currentStyle.add("FONT_SIZE_32");
          default:
            return currentStyle;
        }
      }
      return currentStyle;
    },
    htmlToBlock: (nodeName, node, lastList, inBlock) => {
      if (
        (nodeName === "figure" && node?.firstChild?.nodeName === "IMG") ||
        (nodeName === "img" && inBlock !== "atomic")
      ) {
        return "atomic";
      }
      return undefined;
    },
    htmlToEntity: (nodeName, node, createEntity) => {
      switch (nodeName) {
        case "img": {
          let height;
          if (node.style.height) {
            height = removerCharsNaoNumericos(node.style.height);
          } else if (node.attributes.height) {
            height = node.attributes.height.value;
          }

          let width;
          if (node.style.width) {
            width = removerCharsNaoNumericos(node.style.width);
          } else if (node.attributes.width) {
            width = node.attributes.width.value;
          }

          return createEntity("IMAGE", "IMMUTABLE", {
            attributes: convertAttributesToObject(node.attributes),
            height,
            width,
          });
        }
        case "a": {
          const attributes = convertAttributesToObject(node.attributes);
          const href = node.getAttribute("href");

          const data = {
            attributes,
            href: href || attributes.href || attributes.url,
          };

          if (attributes.id === "linkDescadastro") {
            return createEntity("LINK_DESCADASTRO_CANDENCIA", "IMMUTABLE", { attributes: data });
          }

          if (node.hasAttribute("target")) {
            data.target = node.getAttribute("target");
            data.rel = "noreferrer";
          }

          return createEntity("LINK", "MUTABLE", data);
        }
        default:
          return undefined;
      }
    },
    blockRendererFn,
  })(html);
const camelCaseStyles = styleObj => {
  if (!styleObj) return {};
  return Object.keys(styleObj).reduce((acc, key) => {
    const newKey = camelCase(key);
    acc[newKey] = styleObj[key];
    return acc;
  }, {});
};
export const convertToHTML = (contentState, options) => {
  const styleToHTML = style => {
    if (Object.keys(styleMap).find(itemStyle => itemStyle === style)) {
      if (styleMap[style].fontSize) {
        return <span style={{ fontSize: styleMap[style].fontSize }} />;
      }
      return <span />;
    }
    return undefined;
  };

  const entityToHTML = entity => {
    const extendedEntityToHTML = get(options, "extends.entityToHTML");
    if (extendedEntityToHTML) {
      const retorno = extendedEntityToHTML(entity);
      if (retorno) {
        return retorno;
      }
    }

    switch (entity.type.toUpperCase()) {
      case "IMAGE":
        return ReactDOM.renderToString(<EditorTextoMedia entity={entity} />);
      case "LINK":
      case "LINK_DESCADASTRO_CANDENCIA": {
        const { url, attributes = {}, href } = entity.data;
        let link = href || url || attributes.href || attributes.url;

        if (typeof link === "object") link = "#";

        if (!link || link === "undefined") link = "#";

        const { href: _, url: __, ...cleanAttributes } = attributes;

        const allAttributes = { ...cleanAttributes, href: link };

        const attrs = Object.entries(allAttributes)
          .filter(([key, value]) => {
            if (value === undefined || value === null || value === "undefined") return false;
            if (typeof value === "object" && key !== "style") return false;
            return true;
          })
          .map(([key, value]) => {
            if (typeof value === "object" && key === "style") {
              const styleStr = Object.entries(value)
                .map(([k, v]) => `${k}:${v}`)
                .join(";");
              return `${key}="${styleStr}"`;
            }
            return `${key}="${value}"`;
          })
          .join(" ");
        return { start: `<a ${attrs}>`, end: "</a>" };
      }
      default:
        return undefined;
    }
  };

  const getBlockInnerHTML = block => {
    const singleContentState = ContentState.createFromBlockArray([block], contentState.getEntityMap());
    return convertToHTMLDraftJs({
      styleToHTML,
      blockToHTML: () => ({ start: "<div>", end: "</div>" }),
      entityToHTML,
    })(singleContentState);
  };

  const blocks = contentState.getBlockMap().toArray();
  const htmlParts = [];
  let i = 0;

  while (i < blocks.length) {
    const block = blocks[i];
    const type = block.getType();

    let handled = false;

    if (type === "ordered-list-item") {
      htmlParts.push("<ol>");

      while (i < blocks.length && blocks[i].getType() === "ordered-list-item") {
        const singleContentState = ContentState.createFromBlockArray([blocks[i]], contentState.getEntityMap());

        const html = convertToHTMLDraftJs({
          styleToHTML,
          blockToHTML: () => ({ start: "<li>", end: "</li>" }),
          entityToHTML,
        })(singleContentState);

        htmlParts.push(html);
        i++;
      }

      htmlParts.push("</ol>");
      handled = true;
    }

    if (!handled && type === "unordered-list-item") {
      htmlParts.push("<ul>");

      while (i < blocks.length && blocks[i].getType() === "unordered-list-item") {
        const singleContentState = ContentState.createFromBlockArray([blocks[i]], contentState.getEntityMap());

        const html = convertToHTMLDraftJs({
          styleToHTML,
          blockToHTML: () => ({ start: "<li>", end: "</li>" }),
          entityToHTML,
        })(singleContentState);

        htmlParts.push(html);
        i++;
      }

      htmlParts.push("</ul>");
      handled = true;
    }

    if (!handled && type === "table") {
      const data = block.getData();
      const tableShape = data.get("tableShape");

      if (tableShape) {
        const dataJS = data.toJS();
        const { tableKey, tableStyle, tableColgroup, rowStyle } = dataJS;
        const numCells = tableShape.reduce((acc, row) => acc + row.length, 0);
        const cellContents = [];

        for (let k = 0; k < numCells; k++) {
          const cellBlockIndex = i + k;
          if (cellBlockIndex >= blocks.length) {
            cellContents.push("");
          } else {
            cellContents.push(getBlockInnerHTML(blocks[cellBlockIndex]));
          }
        }

        let cellIndex = 0;
        const tableElem = (
          <table key={tableKey} style={camelCaseStyles(tableStyle)} id={tableKey}>
            {tableColgroup && <colgroup dangerouslySetInnerHTML={{ __html: tableColgroup }} />}
            <tbody>
              {tableShape.map((row, ri) => (
                <tr key={ri} style={camelCaseStyles(rowStyle[ri])}>
                  {row.map((cell, cj) => {
                    const content = cellContents[cellIndex++];
                    if (cell.element === "th") {
                      return (
                        <th
                          key={cj}
                          style={camelCaseStyles(cell.style)}
                          colSpan={cell.colspan}
                          rowSpan={cell.rowspan}
                          dangerouslySetInnerHTML={{ __html: content }}
                        />
                      );
                    }
                    return (
                      <td
                        key={cj}
                        style={camelCaseStyles(cell.style)}
                        colSpan={cell.colspan}
                        rowSpan={cell.rowspan}
                        dangerouslySetInnerHTML={{ __html: content }}
                      />
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        );

        htmlParts.push(ReactDOM.renderToStaticMarkup(tableElem));
        i += numCells;
        handled = true;
      }
    }

    // Se não foi tratado por lista/tabela, processa bloco normal
    if (!handled) {
      const singleContentState = ContentState.createFromBlockArray([block], contentState.getEntityMap());

      const singleHTML = convertToHTMLDraftJs({
        styleToHTML,
        blockToHTML: ({ type: innerBlockType, text }) => {
          switch (innerBlockType) {
            case "atomic":
              return { start: "<figure style='margin: 0;'>", end: "</figure>" };
            case "unstyled":
              if (typeof text === "string" && text.trim() === "") {
                return { start: "<br/>", end: "" };
              }
              return { start: "<div>", end: "</div>" };
            default:
              return { start: "<div>", end: "</div>" };
          }
        },
        entityToHTML,
      })(singleContentState);

      htmlParts.push(singleHTML);
      i++;
    }
  }

  return htmlParts.join("");
};

/** Para ser utilizado no editor */
export const decoratorArray = [
  {
    strategy: findLinkEntities,
    component: EditorTextoDecoratorDinamico("a"),
  },
];

/** Para ser utilizado no ao criar novos editorContents */
export const decorators = new MultiDecorator([new CompositeDecorator(decoratorArray)]);

const findEntities = (entityName, contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity();
    return entityKey !== null && contentState.getEntity(entityKey).getType() === entityName;
  }, callback);
};

function findLinkEntities(...args) {
  findEntities("LINK", ...args);
  findEntities("LINK_DESCADASTRO_CANDENCIA", ...args);
}

const convertAttributesToObject = attributes =>
  reduce(
    attributes,
    (acc, attr) => ({
      ...acc,
      [attr.name]: attr.name === "style" ? convertStyleStringToObject(attr.value) : attr.value,
    }),
    {}
  );

export const getActiveButtons = editorState => {
  const entityKey = getSelectionEntity(editorState);
  let link = false;
  if (entityKey) {
    const contentState = editorState.getCurrentContent();
    const entity = contentState.getEntity(entityKey);
    const entityType = entity.getType();

    if (entityType === "LINK") {
      link = true;
    }
  }

  return {
    link,
  };
};

export const getSelectedText = editorState => {
  const contentState = editorState.getCurrentContent();
  const selection = editorState.getSelection();
  const anchorKey = selection.getAnchorKey();
  const currentContentBlock = contentState.getBlockForKey(anchorKey);
  const start = selection.getStartOffset();
  const end = selection.getEndOffset();

  return currentContentBlock.getText().slice(start, end);
};

export const styleMap = {
  FONT_SIZE_11: {
    fontSize: "11px",
  },
  FONT_SIZE_14: {
    fontSize: "14px",
  },
  FONT_SIZE_18: {
    fontSize: "18px",
  },
  FONT_SIZE_32: {
    fontSize: "32px",
  },
};
